import {CustomGroupSummary} from "./custom-group-summary";
import {ExtraFeeSummary} from "./extra-fee-summary";
import {EnumQuoteServiceSalesType} from "../in/quote/enum-quote-service-sales-type";
import { DeviceConsumableLink } from "../in/quote/device-consumable-link";

export class QuoteServiceSummary {

    public code?: string;
    public contractInfoInputs?: any;
    public appliedPrice?: string;
    public extraFees?: ExtraFeeSummary[];
    public isCustomGroups?: boolean;
    public customGroups?: CustomGroupSummary[];
    public additionalStockAmount?: string;
    public isStockSuppOffered?: boolean;
    public monthlyAmount?: string;
    public weeklyAmount?: string;
    public totalBillingStock?: string
    public salesType: EnumQuoteServiceSalesType;
    public deviceConsumablelinks?: DeviceConsumableLink[];

    constructor(code: string, contractInfoInputs: any, appliedPrice: string, extraFees: ExtraFeeSummary[], isCustomGroups: boolean, customGroups: CustomGroupSummary[], additionalStockAmount: string, isStockSuppOffered: boolean, monthlyAmount: string, weeklyAmount: string, totalBillingStock: string, salesType: EnumQuoteServiceSalesType, deviceConsumablelinks?: DeviceConsumableLink[]) {
        this.code = code;
        this.contractInfoInputs = contractInfoInputs;
        this.appliedPrice = appliedPrice;
        this.extraFees = extraFees;
        this.isCustomGroups = isCustomGroups;
        this.customGroups = customGroups;
        this.additionalStockAmount = additionalStockAmount;
        this.isStockSuppOffered = isStockSuppOffered;
        this.monthlyAmount = monthlyAmount;
        this.weeklyAmount = weeklyAmount;
        this.totalBillingStock = totalBillingStock;
        this.salesType = salesType;
        this.deviceConsumablelinks = deviceConsumablelinks;
    }
}
